import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' // Mapeia o escopo global (IoC nativo do Angular/Ionic)
})
export class ElginPrintService {
  
  private device: any = null;
  
  // Filtros de Hardware USB da Elgin i9 (Vendor IDs)
  private readonly FILTROS_USB = {
    filters: [
      { vendorId: 0x0fe6 }, 
      { vendorId: 0x20d1 }  
    ]
  };

  // O HttpClient do Angular é injetado no construtor (Injeção de Dependência)
  constructor(private http: HttpClient) {}



  /**
   * Abre a caixa de diálogo nativa do navegador para vincular a USB pela primeira vez
   */
  async vincularDispositivo(): Promise<any> {
    try {
      const navUsb = (navigator as any).usb;
      this.device = await navUsb.requestDevice(this.FILTROS_USB);
      return this.device;
    } catch (error) {
      throw new Error('Vinculação cancelada pelo usuário.');
    }
  }

  /**
   * Verifica se o navegador já possui permissão prévia para usar a impressora
   */
  async verificarPermissaoExistente(): Promise<any> {
    const navUsb = (navigator as any).usb;
    if (navUsb) {
      const devices = await navUsb.getDevices();
      if (devices.length > 0) {
        this.device = devices[0];
        return this.device;
      }
    }
    return null;
  }

  async enviarParaImpressora(textoPuro: string): Promise<void> {
    //const comandosEscPos = '\x1B@' + textoPuro + '\n\n\n\n\x1DV\x42\x00';
    this.http.post("http://localhost:8080/api/impressao", textoPuro).subscribe(
      (res) => {console.log(res)}
    );
  }
    
}
